export default {
  permissionMenuMap: {
    'dashboard': '控制面板',
    'admin': '管理',
    'admin:user': '用户',
    'admin:role': '角色',
    'admin:permission': '权限',
    'admin:driver':'司机',
    'admin:userOrder':'用户订单'
  }
};



// WEBPACK FOOTER //
// ./../../../../小梁/Desktop/reservation_server/web/src/constant.js